import React from "react";
import "./About.css"; // We will create this CSS file next

function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I'm a versatile software developer specializing in the .NET
              ecosystem (C#, MSSQL) and web platforms (Javascript, HTML, CSS)
              with a passion for architecting and deploying robust, scalable
              applications within cloud environments. My experience spans the
              full software development lifecycle, from initial design and
              development to rigorous testing, automated CI/CD pipelines,
              documentation, and ongoing maintenance. I’m deeply familiar with
              Google Cloud Platform (GCP), utilizing services like Cloud Run,
              Firebase, and VMs to build and manage production-ready systems. I
              leverage infrastructure-as-code principles and automated
              deployment strategies to ensure reliability, scalability, and
              efficient resource utilization.
            </p>
            <p>
              My holistic approach extends beyond coding itself. I'm comfortable
              managing cloud resources, configuring networking, and integrating
              Large Language Models (LLMs) where appropriate. I'm adept at
              building full-stack solutions in multiple languages, often
              delivering end-to-end production solutions independently, from
              initial design and development to implementation and ongoing
              maintenance and documentation.
            </p>
            <p>
              As a lifelong learner, I’m committed to staying at the forefront
              of cloud technologies and DevOps practices. I thrive on tackling
              complex challenges, optimizing performance, and building
              resilient, scalable systems that meet evolving business needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
